shadow$provide[33] = function(global,require,module,exports) {
module.exports=(ReactDOM);
};